import { Body } from '@workramp/ui';
import { useTheme } from 'styled-components';

interface CMSAssetWarningProps {
  warningMessage: string;
}

export const CMSAssetWarning = ({ warningMessage }: CMSAssetWarningProps) => {
  const theme = useTheme();
  return (
    <Body color={theme.colors.warning[400]} level="md">
      {warningMessage}
    </Body>
  );
};
